// @flow
const processingViewStyles = {
  container: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 600,
    margin: '0 auto'
  }),

  content: (theme: Object) => ({
    width: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`
  }),

  header: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3)
  }),

  spinner: (theme: Object) => ({
    color: theme.palette.primary.main
  }),

  successIcon: (theme: Object) => ({
    fontSize: 32,
    color: theme.palette.success.main
  }),

  title: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.text.primary
  }),

  progressContainer: (theme: Object) => ({
    marginBottom: theme.spacing(3)
  }),

  progressBar: (theme: Object) => ({
    height: 12,
    borderRadius: 6,
    backgroundColor: theme.palette.divider,
    '& .MuiLinearProgress-bar': {
      borderRadius: 6,
      backgroundColor: theme.palette.primary.main
    }
  }),

  progressInfo: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1)
  }),

  statusText: (theme: Object) => ({
    color: theme.palette.text.secondary
  }),

  progressPercent: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.primary.main
  }),

  counters: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'space-around',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius
  }),

  counter: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flex: 1
  }),

  counterIcon: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: theme.palette.background.paper
  }),

  createdIcon: (theme: Object) => ({
    color: theme.palette.success.main,
    fontSize: 20
  }),

  skippedIcon: (theme: Object) => ({
    color: theme.palette.warning.main,
    fontSize: 20
  }),

  failedIcon: (theme: Object) => ({
    color: theme.palette.error.main,
    fontSize: 20
  }),

  counterValue: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1,
    marginTop: theme.spacing(0.5)
  }),

  counterLabel: (theme: Object) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center'
  }),

  hint: (theme: Object) => ({
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontStyle: 'italic'
  })
};

export default processingViewStyles;
